import { Box, Button, Icon, IconButton, TextField, Typography } from '@mui/material';
import React from 'react';

interface SingleEditTextProps {
    header: string;
    value?: string;
    /** text to display in read only mode, when value is empty*/
    emptyText?: string;

    // for textfield
    rows?: number | string;
    rowsMax?: number | string;
    className?: string;

    onSave: (newValue: string) => void;
}

interface SingleEditTextState {
    editing: boolean;
    currentValue: string;
}

export class SingleEditText extends React.Component<SingleEditTextProps, SingleEditTextState> {
    public constructor(props: Readonly<SingleEditTextProps> | SingleEditTextProps) {
        super(props);

        this.state = {
            editing: false,
            currentValue: props.value || '',
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    public render(): React.ReactNode {
        const isMultiline = 0 < Number(this.props.rows) + Number(this.props.rowsMax);
        if (this.state.editing) {
            return (
                <Box className={this.props.className}>
                    <TextField
                        className='mb-2'
                        fullWidth
                        label={this.props.header}
                        multiline={isMultiline}
                        rows={this.props.rows}
                        maxRows={this.props.rowsMax}
                        value={this.state.currentValue}
                        onChange={this.handleChange}
                    />
                    <Button type='button' variant='outlined' color='primary' onClick={this.handleSave}>
                        Save {this.props.header}
                    </Button>
                </Box>
            );
        }

        return (
            <Box className={this.props.className}>
                <Typography variant='h6'>
                    {this.props.header}
                    <IconButton onClick={() => this.setState({ editing: true })} size='large'>
                        <Icon fontSize='small'>edit_mode</Icon>
                    </IconButton>
                </Typography>
                <Typography style={{ overflowWrap: 'break-word' }}>{this.getViewData(isMultiline)}</Typography>
            </Box>
        );
    }

    private handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ currentValue: evt.target.value });
    }

    private handleSave() {
        this.props.onSave(this.state.currentValue);
        this.setState({ editing: false });
    }

    private getViewData(isMultiline: boolean) {
        if (!this.state.currentValue) {
            return (
                <Typography component='span' color='textSecondary'>
                    {this.props.emptyText || ''}
                </Typography>
            );
        }

        if (isMultiline) {
            return this.state.currentValue.split('\n').map((text, key) => (
                <span key={key}>
                    {text}
                    <br />
                </span>
            ));
        }

        return this.state.currentValue;
    }
}
